import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className,
  id,
  delay = 0
}: SectionProps) {
  return <section id={id} className={clsx('py-16 md:py-24 px-4 md:px-6 w-full overflow-hidden', className)} data-id="element-173">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-174">
        {children}
      </motion.div>
    </section>;
}